/* Chumart: <recently-viewed> 自定义元素
   原本内联在 sections/recently-viewed.liquid 里。挪到这里有两个原因：
     1. themeFilesUpsert 单文件约 13.6KB 就会失败，section 文件塞不下了
     2. 这段 JS 不含任何 Liquid，天然适合做成 asset（可被浏览器缓存）

   Chumart 的改动：
     1. 不再 window.initLazyScript(this, init, 500)，构造即 init（见 section 里的预取）
     2. 前 8 张主图改 eager，避免叠加懒加载延迟
     3. li 去掉 data-cc-animate（在 section 的 Liquid 里）
     4. 补满整排，优先级：浏览过的 > 同系列(custom.size/style) > Shopify 推荐兜底
     5. **一次渲染**：补的卡片在插入 DOM 之前就并进同一个 ul，
        避免「先出浏览过的、过 300ms 再跳出推荐的」那种两段式闪烁。
        顺带好处：carousel-slider 构造时卡片已经是全的，正常路径不用再 refresh。
*/
(function () {
  if (customElements.get('recently-viewed')) return;

  // 补满请求的最长等待。超时就先把浏览记录渲染出来，补的晚点到，
  // 不能因为补不上就整排都不显示。实测两次请求共约 500ms。
  const FILL_TIMEOUT = 1500;

  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.fetchAttempts = 0;
      setTimeout(() => this.init(), 0);
    }

    async init() {
      try {
        const text = this.cmPrefetch
          ? await this.cmPrefetch
          : await (await fetch(`${this.dataset.url}&q=${this.getSearchQuery()}`)).text();

        const tmpl = document.createElement('template');
        tmpl.innerHTML = text;

        const el = tmpl.content.querySelector('recently-viewed');
        if (!el || !el.hasChildNodes()) return;

        const ul = el.querySelector('ul');
        let pending = null;

        if (ul) {
          // 按浏览顺序重排（搜索接口返回的顺序不是浏览顺序）
          this.getItems().forEach((item) => {
            const card = ul.querySelector(`product-card[data-product-id="${item}"]`);
            const li = card ? card.closest('li') : null;
            if (li) ul.appendChild(li);
          });

          // 补满：赶得上就在插入 DOM 之前并进去（一次渲染）
          pending = this.collectFill(ul);
          const lis = await Promise.race([pending, this.after(FILL_TIMEOUT)]);
          if (lis) {
            lis.forEach((li) => ul.appendChild(li));
            pending = null;
          }
        }

        this.innerHTML = el.innerHTML;
        this.eagerImages(this);

        // 赶不上的兑底：晚到就补到线上 DOM，再叫轮播重算
        if (pending) {
          pending.then((late) => {
            if (!late || !late.length) return;
            const live = this.querySelector('ul');
            if (!live) return;
            late.forEach((li) => {
              this.eagerImages(li);
              live.appendChild(li);
            });
            this.refreshSlider();
          });
        }
      } catch (error) {
        this.cmPrefetch = null;
        this.fetchAttempts += 1;

        if (this.fetchAttempts === 3) {
          console.log(error);
        } else {
          this.init();
        }
      }
    }

    after(ms) {
      return new Promise((resolve) => setTimeout(() => resolve(null), ms));
    }

    /* 卡片主图默认 loading="lazy"，要滚到跟前才下载，叠上异步拉取就显得很慢。
       前 8 张改成立刻加载，其余（hover 备用图等）保持 lazy。 */
    eagerImages(root) {
      Array.prototype.slice.call(root.querySelectorAll('.card__main-image'), 0, 8)
        .forEach((img) => {
          img.loading = 'eager';
          img.fetchPriority = 'high';
        });
    }

    /* 算出要补的卡片并返回 <li> 数组（**不直接插入**，由调用方决定插哪里）。
       传进来的 ul 此时还是游离的 template 节点，querySelector 照样能用。
       优先级：
         1. 浏览过的（已在 ul 里）
         2. 种子产品的 custom.size / custom.style —— 确定性的同系列不同尺寸/门型，
            不看订单量脸色。id 列表由 Liquid 写在 li 的 data-cm-family 上，
            跟浏览记录卡片同一次请求带回来，不多发请求。
         3. 还不够，才用 Shopify 原生推荐（/recommendations/products.json, intent=related）兜底
       补进来的卡片统一走 recently-viewed 自己的 section 渲染接口，
       和浏览记录卡片是同一套 markup，样式完全一致。 */
    async collectFill(ul) {
      if (this.dataset.fill !== 'true') return [];
      try {
        const limit = Number(this.dataset.limit) || 8;
        const taken = Array.prototype.slice
          .call(ul.querySelectorAll('product-card[data-product-id]'))
          .map((c) => Number(c.dataset.productId));
        const need = limit - taken.length;
        if (need < 1) return [];

        const exclude = this.dataset.exclude ? Number(this.dataset.exclude) : 0;
        const seed = exclude || this.getItems()[0];
        const pick = [];
        const add = (id) => {
          if (id && id !== exclude && taken.indexOf(id) === -1 && pick.length < need) {
            pick.push(id);
            taken.push(id);
          }
        };

        // 2) 同系列（尺寸梯子 + 门型）
        const seedCard = ul.querySelector(`product-card[data-product-id="${seed}"]`);
        const seedLi = seedCard ? seedCard.closest('li') : null;
        if (seedLi && seedLi.dataset.cmFamily) {
          seedLi.dataset.cmFamily.split(',').forEach((s) => add(Number(s)));
        }

        // 3) 算法推荐兜底
        if (pick.length < need && this.cmRec) {
          const data = await this.cmRec;
          ((data && data.products) || []).forEach((p) => add(p.id));
        }

        if (!pick.length) return [];

        const q = pick.map((id) => `id:${id}`).join(' OR ');
        const html = await (await fetch(`${this.dataset.url}&q=${encodeURIComponent(q)}`)).text();

        const t = document.createElement('template');
        t.innerHTML = html;

        // 按 pick 的顺序返回，而不是按搜索接口返回的顺序
        const out = [];
        pick.forEach((id) => {
          const card = t.content.querySelector(`product-card[data-product-id="${id}"]`);
          const li = card ? card.closest('li') : null;
          if (li) out.push(li);
        });
        return out;
      } catch (e) {
        return [];
      }
    }

    /* 只有「超时兑底」那条路会用到（正常路径卡片是插入前就并好的）。
       坑：主题里有两份 CarouselSlider——assets/slider.js 那份有公开的 refresh()，
       但实测页面上加载的是 **assets/main.js** 里的旧版，**没有 refresh()**。
       所以两种都得兼容；旧版就手动重跑 handleResize() 的那两步。 */
    refreshSlider() {
      const slider = this.querySelector('carousel-slider');
      if (!slider) return;

      if (typeof slider.refresh === 'function') {
        slider.refresh();
        return;
      }
      if (slider.hasAttribute('loaded') && typeof slider.initSlider === 'function') {
        if (typeof slider.removeListeners === 'function') slider.removeListeners();
        slider.initSlider();
      }
    }

    getSearchQuery() {
      return this.getItems().map((item) => `id:${item}`).slice(0, this.dataset.limit).join(' OR ');
    }

    getItems() {
      let items = [];
      try {
        items = JSON.parse(localStorage.getItem('cc-recently-viewed') || '[]');
      } catch (e) {
        return [];
      }

      if (this.dataset.exclude && items.includes(Number(this.dataset.exclude))) {
        items.splice(items.indexOf(Number(this.dataset.exclude)), 1);
      }

      return items;
    }
  }

  customElements.define('recently-viewed', RecentlyViewed);
})();
